import instance from './testing.instance';

//Consulta info planes.
export const getpaymentInfo = () => instance.get(`/pagos/`);
export const getPaymentCompliance = (accept) => {
  const queryParam = accept ? '?aceptacion=True' : '';
  return instance.get(`/pagos/compliance${queryParam}`);
};
export const purchasePlan = (body) => instance.post(`/pagos/`, body);
export const changeStateOrder = (body) => instance.patch(`/pagos/`, body);
export const getLastOrderWithAddons = () => instance.get(`/pagos/addons`);
export const getPaymentStaffInfo = (page, pageSize, filters = {}) => {
  const params = new URLSearchParams();

  if (page) params.append('page', page);
  if (pageSize) params.append('page_size', pageSize);

  Object.entries(filters).forEach(([key, value]) => {
    if (value !== '' && value !== null && value !== undefined) {
      params.append(key, value);
    }
  });

  return instance.get(`/pagos/staff?${params.toString()}`);
};
export const getTransferPayments = (page, pageSize) => instance.get('/pagos/staff/transferencia/', { params: { page, page_size: pageSize } });
export const confirmTransferPayment = (compraId) => instance.post('/pagos/staff/transferencia/', { compra_id: compraId });
export const cancelPurchase = (compraId) => instance.patch('/pagos/', { compra_id: compraId, estado: 2 });
export const getPendingInvoices = (params = {}) => { return instance.get('pagos/staff/facturacion/', { params }); };
export const markAsInvoiced = (payload) => {
  const isFormData = payload instanceof FormData;
  return instance.post(
    'pagos/staff/facturacion/',
    payload,
    isFormData
      ? {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
      : undefined
  );
};
export const getBillPDF = (compraId) => {
  return instance.get(`pagos/factura/${compraId}/descargar/`, {
    responseType: 'blob',
  });
};
export const deleteBill = (compraId) =>
  instance.delete('/pagos/staff/facturacion/', {
    data: {
      compra_id: compraId,
    },
  });
export const unsubscribePlan = (compraId) => instance.patch('/pagos/', { compra_id: compraId, estado: 10 });
export const vencerplan = () => instance.post(`/pagos/simular_vencimiento/`);
export const getSuscriptions = (page, pageSize, filters = {}) => {
  const params = new URLSearchParams();

  if (page) params.append('page', page);
  if (pageSize) params.append('page_size', pageSize);

  Object.entries(filters).forEach(([key, value]) => {
    if (value !== '' && value !== null && value !== undefined) {
      params.append(key, value);
    }
  });

  return instance.get(`/pagos/staff/suscripciones?${params.toString()}`);
};
export const cancelSubscription = (reference, devMode) => instance.post('/pagos/staff/suscripciones/cancelar/', { reference: reference, dev: devMode || false });
export const payDebt = (body) => instance.post(`/pagos/saldar-deuda/`, body);
export const consentDowngrade = (activate = true) => instance.post(`/pagos/consentimiento-downgrade/`, { activar: activate });
export const getDowngradeApprovals = (page, pageSize, filters = {}) => {
  const params = new URLSearchParams();
  if (page) params.append('page', page);
  if (pageSize) params.append('page_size', pageSize);
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== '' && value !== null && value !== undefined) {
      params.append(key, value);
    }
  });
  return instance.get(`/pagos/staff/downgrades/aprobaciones/?${params.toString()}`);
};
export const approveDowngrade = (id, motivo) => instance.post(`/pagos/staff/downgrades/aprobaciones/${id}/aprobar/`, { motivo: motivo || '' });
export const rejectDowngrade = (id, motivo) => instance.post(`/pagos/staff/downgrades/aprobaciones/${id}/rechazar/`, { motivo: motivo || '' });